import { render, staticRenderFns } from "./LearningGoalsWithLessons.vue?vue&type=template&id=a4678cf8&"
import script from "./LearningGoalsWithLessons.vue?vue&type=script&lang=js&"
export * from "./LearningGoalsWithLessons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports